import { IconButton } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { useState } from 'react';
import PropTypes from 'prop-types';

const CollapseButton = ({ onClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <IconButton
      onClick={() => {
        if (onClick) {
          onClick(!isCollapsed);
          setIsCollapsed(!isCollapsed);
        }
      }}
    >
      {isCollapsed ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
    </IconButton>
  );
};

CollapseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CollapseButton;
